const serviceSections = document.querySelectorAll(".service-section");

serviceSections.forEach((section) => {
    const serviceNames = section.querySelectorAll(".service-name");
    const serviceDescriptions = section.querySelectorAll(".service-description");

    serviceNames.forEach((serviceName) => {
        serviceName.addEventListener("click", () => {
            if (!serviceName.classList.contains("current")) {
                serviceNames.forEach((name) => {
                    name.classList.remove("current");
                    name.ariaSelected = "false";
                });
                serviceDescriptions.forEach((description) => {
                    description.classList.remove("current");
                    description.ariaSelected = "false";
                });
                serviceName.classList.add("current");
                serviceName.ariaSelected = "true";
                serviceName.ariaControlsElements.forEach((description) => {
                    description.classList.add("current");
                    description.ariaSelected = "true";
                });
            }
        });
    });
});
